import { Badge, Box } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';

export const MoonSunAvailabilityIcons = (
  props: PickersDayProps & {
    highlightedDays?: Record<string, 'morning' | 'afternoon' | 'both' | null>;
  },
) => {
  const { highlightedDays = {}, day, outsideCurrentMonth, ...other } = props;

  const availability = highlightedDays[day.format('YYYY-MM-DD')];
  const isAvailable = !outsideCurrentMonth && availability;

  return (
    <Badge
      key={day.toString()}
      overlap="circular"
      badgeContent={
        isAvailable ? (
          <Box
            sx={{
              display: 'flex',
              gap: 0.25,
              position: 'absolute',
              bottom: 2,
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          >
            {(availability === 'morning' || availability === 'both') && (
              <LightModeIcon color="primary" sx={{ width: 11, height: 11 }} />
            )}
            {(availability === 'afternoon' || availability === 'both') && (
              <BedtimeIcon color="primary" sx={{ width: 11, height: 11 }} />
            )}
          </Box>
        ) : undefined
      }
    >
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        sx={{
          ...(isAvailable && {
            backgroundColor: 'success.light',
            '&:hover': {
              backgroundColor: 'success.main',
            },
          }),
        }}
      />
    </Badge>
  );
};
